import axios from "axios";
import { getCookie } from "../utils/cookies";


const baseUrl = 'https://www.elpelobetxi.com/WS/'
const ticketsBaseUrl = 'https://www.elpelobetxi.com/'


//////////////////////////////tessa ticketes//////////////////////////////////////////////////////

export const postTegistrarTicket = async (data, archivo) => {
    try {
        // Crear un objeto FormData
        const formData = new FormData();
        formData.append('token', getCookie('PHPSESSID'));
        formData.append('data', JSON.stringify(data)); // Convertir los datos a JSON

        formData.append('file[]', archivo);
        const response = await axios.post(ticketsBaseUrl + 'ticketSign.php?', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Indicar que se usa multipart/form-data
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al enviar la tarea:', error);
        return null;
    }
};

//////////////////////////////tessa management//////////////////////////////////////////////////////
//gets
export const getopcinesMenu = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesmenu.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error;
    }
};


export const getProyectos = async (oculto) => {
    try {
        const response = await axios.get(baseUrl + 'proyectos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                oculto: oculto
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};



export const postProyecto = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'postProyecto.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


export const getOpcionesProyectos = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesProyectos.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getOpcionesEditProyectos = async () => {
    // try {
    //     const response = await axios.get(baseUrl + 'opcionesProyectos.php?', {
    //         params: { token: getCookie('PHPSESSID') },
    //     });

    //     if (response.data.success) {
    //         // Procesar la respuesta y actualizar las opciones si es necesario
    //         return response.data;
    //     } else {
    //         console.log('Error');
    //         return null;
    //     }
    // } catch (error) {
    //     console.error('Error al verificar el token:', error);
    //     return null;
    // }
}


export const getProyecto = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'proyectos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getInfoProyecto = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'proyectos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};



export const getTareas = async (id, tipo, fechaDesde, fechaHasta, estadosFitlro) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'tareas.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo,
                fechaDesde: fechaDesde,
                fechaHasta: fechaHasta,
                estados: estadosFitlro
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};
export const getTodasTareas = async (id, tipo, fechaDesde, fechaHasta, estadosFitlro, limit, page, proyectosFiltro, empleadosFiltro, clientesFiltro, searchTerm) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'todastareastest.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo,
                fechaDesde: fechaDesde,
                fechaHasta: fechaHasta,
                estados: estadosFitlro,
                limit: limit,
                page: page,
                empleados: empleadosFiltro,
                clientes: clientesFiltro,
                proyectos: proyectosFiltro,
                searchTerm: searchTerm

            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const eliminarTarea = async (id) => {
    try {
        const response = await axios.delete(baseUrl + 'deleteTarea.php?', {
            data: {
                token: getCookie('PHPSESSID'),
                data: id
            }

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }

}
export const getTarea = async (id, id_tarea, tipo) => {
    try {
        const response = await axios.get(baseUrl + 'tareas.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                id_tarea: id_tarea,
                tipo: tipo
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postTarea = async (data, archivos) => {
    try {
        // Crear un objeto FormData
        const formData = new FormData();
        formData.append('token', getCookie('PHPSESSID'));
        formData.append('data', JSON.stringify(data)); // Convertir los datos a JSON
        if (archivos) {
            archivos.forEach((archivo) => {
                formData.append('file[]', archivo);
            });

        }

        const response = await axios.post(baseUrl + 'postTarea.php?', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Indicar que se usa multipart/form-data
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al enviar la tarea:', error);
        return null;
    }
};



export const postSA = async (data, archivos) => {
    try {
        const formData = new FormData();
        formData.append('token', getCookie('PHPSESSID'));
        formData.append('data', JSON.stringify(data)); // Convertir los datos a JSON
        if (archivos) {
            archivos.forEach((archivo) => {
                formData.append('file[]', archivo);
            });

        }

        const response = await axios.post(baseUrl + 'postSA.php?', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Indicar que se usa multipart/form-data
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al enviar la tarea:', error);
        return null;
    }

}
export const getTareaSA = async (id, tipo, fechaDesde, fechaHasta, estadosFitlro, limit, page, proyectosFiltro, empleadosFiltro, clientesFiltro, searchTerm) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'tareasSA.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo,
                fechaDesde: fechaDesde,
                fechaHasta: fechaHasta,
                estados: estadosFitlro,
                limit: limit,
                page: page,
                empleados: empleadosFiltro,
                clientes: clientesFiltro,
                proyectos: proyectosFiltro,
                searchTerm: searchTerm

            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const getInfoTareaSA = async (id_tarea) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'tareasSA.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id_tarea: id_tarea,
                id: 0,

            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};
export const getEstados = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'estados.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
//ticket
export const getTickets = async (id, tipo) => {
    try {
        const response = await axios.get(baseUrl + 'tickets.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const postTickets = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'postTicket.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
//trabajadores
export const getTrabajadores = async (tarea) => {
    try {
        const response = await axios.get(baseUrl + 'trabajadores.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const getOpcionesTickets = async (id, tipo) => {
    try {
        const response = await axios.get(baseUrl + 'opcionestickets.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id,
                tipo: tipo
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}
//acltualizar tarea
export const actualizarTarea = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'actualizarTarea.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//acltualizar proyectos
export const updateProyecto = async (data) => {

    console.log(getCookie('PHPSESSID'));

    try {
        const response = await axios.put(baseUrl + 'proyectos.php?', {
            token: getCookie('PHPSESSID'),
            data: data,
            _t: Date.now() // ← esto evita la caché del navegador
        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getPrueba = async () => {
    try {
        const response = await axios.get('http://93.189.90.30/test', {

        });

        if (response) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response;
        } else {
            console.log('Error s');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}


//post
//tareas
//comentarios

export const postComentarioTarea = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'comentariosTareas.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postComentarioTareaInter = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'comentariosTareasInterno.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


//opciones tareas
export const getOpcionesTareas = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'opcionestareas.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}
//update tareas

export const updateTarea = async (tarea) => {
    try {
        const response = await axios.get(baseUrl + 'tareas.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: tarea
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
//tiempo Tareas

//iniciar
export const inicioTarea = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'tiempoTarea.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
//clientes

export const getClientes = async () => {
    try {
        const response = await axios.get(baseUrl + 'clientes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getMarcaCliente = async () => {
    try {
        const response = await axios.get(baseUrl + 'marcaCliente.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al cargar marca del cliente:', error);
        return null;
    }
};

export const getConfiguracionCliente = async () => {
    try {
        const response = await axios.get(baseUrl + 'configuracionCliente.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al cargar configuración del cliente:', error);
        return null;
    }
};

export const actualizarConfiguracionCliente = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'configuracionCliente.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al actualizar configuración del cliente:', error);
        return null;
    }
};

export const getTiposTickets = async (mostrar = 1, anyo = new Date().getFullYear()) => {
    try {
        const response = await axios.get(baseUrl + 'tiposTickets.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                mostrar,
                anyo
            },
        });

        return response.data;
    } catch (error) {
        console.error('Error al carregar tipus de tiquets:', error);
        return null;
    }
};

export const clonarTiposTickets = async (anyo, anyoOrigen = Number(anyo) - 1) => {
    try {
        const response = await axios.post(baseUrl + 'tiposTickets.php?', {
            token: getCookie('PHPSESSID'),
            data: {
                accion: 'clonar',
                anyo,
                anyo_origen: anyoOrigen
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error al clonar tipus de tiquets:', error);
        return null;
    }
};

export const crearTipoTicket = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'tiposTickets.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al crear tipus de tiquet:', error);
        return null;
    }
};

export const actualizarTipoTicket = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'tiposTickets.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al actualitzar tipus de tiquet:', error);
        return null;
    }
};

export const eliminarTipoTicket = async (id) => {
    try {
        const response = await axios.delete(baseUrl + 'tiposTickets.php?', {
            data: {
                token: getCookie('PHPSESSID'),
                data: { id }
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error al eliminar tipus de tiquet:', error);
        return null;
    }
};

export const getCategoriasTickets = async () => {
    try {
        const response = await axios.get(baseUrl + 'categoriasTickets.php?', { params: { token: getCookie('PHPSESSID') } });
        return response.data;
    } catch (error) {
        console.error('Error al carregar categories de tiquets:', error);
        return null;
    }
};

export const crearCategoriaTicket = async (nombre) => {
    try {
        const response = await axios.post(baseUrl + 'categoriasTickets.php?', { token: getCookie('PHPSESSID'), data: { nombre } });
        return response.data;
    } catch (error) {
        console.error('Error al crear categoria de tiquet:', error);
        return null;
    }
};

export const actualizarCategoriaTicket = async (id, nombre) => {
    try {
        const response = await axios.put(baseUrl + 'categoriasTickets.php?', { token: getCookie('PHPSESSID'), data: { id, nombre } });
        return response.data;
    } catch (error) {
        console.error('Error al actualitzar categoria de tiquet:', error);
        return null;
    }
};

export const eliminarCategoriaTicket = async (id) => {
    try {
        const response = await axios.delete(baseUrl + 'categoriasTickets.php?', { data: { token: getCookie('PHPSESSID'), data: { id } } });
        return response.data;
    } catch (error) {
        console.error('Error al eliminar categoria de tiquet:', error);
        return null;
    }
};

//fichajes
export const inicioFichaje = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'fichajes.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getFichaje = async (fecha) => {
    try {
        const response = await axios.get(baseUrl + 'fichajes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                fecha: fecha
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const finFichaje = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'fichajes.php??', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            console.log(response);
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const getTodosFichajes = async (fechaDesde, fechaHasta, usuarios) => {
    try {
        const response = await axios.get(baseUrl + 'allfichajes.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                fechaDesde,
                fechaHasta,
                usuarios
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getTodosFichajesDescarga = async (fechaDesde, fechaHasta, usuarios) => {
    try {
        const response = await axios.post(baseUrl + 'allfichajesdescarga.php', {
            token: getCookie('PHPSESSID'),
            fechaDesde,
            fechaHasta,
            usuarios
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.log('Error en la respuesta del servidor');
            return null;
        }
    } catch (error) {
        console.error('Error al obtener los fichajes para descarga:', error);
        return null;
    }
};
export const getFichajesUsuario = async (mes, year, id) => {
    try {
        const response = await axios.get(baseUrl + 'fichajeUsuario.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                mes: mes,
                year: year,
                id: id
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//recursos humanos
export const getOpcionesRrhh = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesrrhh.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//usuarios
export const getUsuarios = async () => {
    try {
        const response = await axios.get(baseUrl + 'usuarios.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const getUsuariosCliente = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'usuarios.php?', {
            params: { token: getCookie('PHPSESSID'), id: id },

        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}


export const postUsuario = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'usuario.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }

}

export const postCliente = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'clientes.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return error.data;
    }

}

export const actualizarCliente = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'clientes.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al actualizar cliente:', error);
        return null;
    }
}

export const delCliente = async (id) => {
    try {
        const response = await axios.delete(baseUrl + 'clientes.php?', {
            data: {
                token: getCookie('PHPSESSID'),
                data: id
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error al eliminar cliente:', error);
        return null;
    }
}

export const delUsuario = async (id) => {
    try {
        const response = await axios.delete(baseUrl + 'usuario.php?', {
            data: {
                token: getCookie('PHPSESSID'),
                data: id
            }

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }

}
export const actualizarUsuario = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'usuario.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return response.data;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getMisUsuarios = async () => {
    try {
        const response = await axios.get(baseUrl + 'misUsuarios.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        return response.data;
    } catch (error) {
        console.error('Error al cargar mis usuarios:', error);
        return null;
    }
}

export const postMisUsuario = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'misUsuarios.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al crear usuario del cliente:', error);
        return null;
    }
}

export const actualizarMisUsuario = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'misUsuarios.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al actualizar usuario del cliente:', error);
        return null;
    }
}

export const delMisUsuario = async (id) => {
    try {
        const response = await axios.delete(baseUrl + 'misUsuarios.php?', {
            data: {
                token: getCookie('PHPSESSID'),
                data: id
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error al eliminar usuario del cliente:', error);
        return null;
    }
}

export const getMiUsuario = async () => {
    try {
        const response = await axios.get(baseUrl + 'miUsuario.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        return response.data;
    } catch (error) {
        console.error('Error al cargar mi usuario:', error);
        return null;
    }
}

export const actualizarMiUsuario = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'miUsuario.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al actualizar mi usuario:', error);
        return null;
    }
}

//administrador
export const getOpcionesAdmin = async () => {
    try {
        const response = await axios.get(baseUrl + 'opcionesAdministrador.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

//roles y permisos
export const getRolesYDepartamentos = async () => {
    try {
        const response = await axios.get(baseUrl + 'rolesydepartamentos.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const actualizarRolesYDepartamentos = async (data, option, rolid) => {
    try {
        const response = await axios.put(baseUrl + 'rolesydepartamentos.php??', {
            token: getCookie('PHPSESSID'),
            option: option,
            rolid: rolid,
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            console.log(response);
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

//crear ticket
export const getDataCrearTicket = async () => {
    try {
        const response = await axios.get(baseUrl + 'dataCrearTIcket.php?', {
            params: { token: getCookie('PHPSESSID') },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

///////////taller//////////////

export const getTaller = async (tipo, fechaDesde, fechaHasta, estadosFiltroStr) => {
    // el tipo es para saber que tipo de opciones hay que cargar
    try {
        const response = await axios.get(baseUrl + 'taller.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                tipo: tipo,
                fechaDesde: fechaDesde,
                fechaHasta: fechaHasta,
                estados: estadosFiltroStr
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);

        return { error: 407 };
    }
};

export const postTareaTaller = async (data, archivos) => {
    try {
        // Crear un objeto FormData
        const formData = new FormData();
        formData.append('token', getCookie('PHPSESSID'));
        formData.append('data', JSON.stringify(data)); // Convertir los datos a JSON
        if (archivos) {
            archivos.forEach((archivo) => {
                formData.append('file[]', archivo);
            });

        }

        const response = await axios.post(baseUrl + 'postTareaTaller.php?', formData, {
            headers: {
                'Content-Type': 'multipart/form-data', // Indicar que se usa multipart/form-data
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al enviar la tarea:', error);
        return null;
    }
};

export const getOpcionesTareasTaller = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'opcionestareasTaller.php??', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}
export const getEstadosTaller = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'estadosTaller.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const actualizarTareaTaller = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'actualizarTareaTaller.php??', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getTareaTaller = async (id_tarea) => {
    try {
        const response = await axios.get(baseUrl + 'taller.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id_tarea: id_tarea,
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const postComentarioTaller = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'comentariosTaller.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getSeguimientoTaller = async (token) => {
    try {
        const response = await axios.get(baseUrl + 'seguimientoTaller.php?', {
            params: { token: token },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


export const getTareasCalendario = async (token) => {
    try {
        const response = await axios.get(baseUrl + 'eventosCalendario.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getProximosEventos = async (fecha) => {
    try {
        const response = await axios.get(baseUrl + 'proximosEventos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                data: fecha
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getJornadas = async () => {
    try {
        const response = await axios.get(baseUrl + 'jornadas.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const getTodosFichajesAuditoria = async (fechaDesde, fechaHasta, usuarios) => {
    try {
        const response = await axios.post(baseUrl + 'allfichajesauditoria.php', {
            token: getCookie('PHPSESSID'),
            fechaDesde,
            fechaHasta,
            usuarios
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.log('Error en la respuesta del servidor');
            return null;
        }
    } catch (error) {
        console.error('Error al obtener los fichajes para descarga:', error);
        return null;
    }
};

export const putTiempoTrabajadoTarea = async (data, id_tarea) => {

    try {
        const response = await axios.put(baseUrl + 'actualizarTiempotrabajadoTarea.php?', {
            token: getCookie('PHPSESSID'),
            data,
            id_tarea: id_tarea

        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getVersion = async (versionLocal) => {

    try {
        const response = await axios.get(baseUrl + 'controlVersion.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                versionLocal: versionLocal
            },
        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


/////////////////////// el pelo


export const getDatosContables = async (fechaDesde, fechaHasta) => {
    try {
        const response = await axios.get(baseUrl + 'contabilidad.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                fechaDesde: fechaDesde,
                fechaHasta: fechaHasta
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postTipoIngreso = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'postTipoIngreso.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postIngresoApartado = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'postIngresoApartado.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return response.data;
        }
    } catch (error) {
        console.error('Error al crear ingreso:', error);
        return error.response?.data || null;
    }
};

export const postApartado = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'postApartado.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
}

export const getAniosContabilidad = async () => {
    try {
        const response = await axios.get(baseUrl + 'contabilidadConfiguracion.php', { params: { token: getCookie('PHPSESSID') } });
        return response.data;
    } catch (error) { return null; }
};

export const gestionarAnyoContabilidad = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'contabilidadConfiguracion.php', { token: getCookie('PHPSESSID'), data });
        return response.data;
    } catch (error) { return error.response?.data || null; }
};

export const getConceptosContabilidadActivos = async () => {
    try {
        const response = await axios.get(baseUrl + 'conceptosContabilidad.php', { params: { token: getCookie('PHPSESSID') } });
        return response.data;
    } catch (error) { return null; }
};

export const actualizarEstadoConceptoContabilidad = async (id_apartado, activo) => {
    try {
        const response = await axios.put(baseUrl + 'conceptosContabilidad.php', { token: getCookie('PHPSESSID'), data: { id_apartado, activo } });
        return response.data;
    } catch (error) { return error.response?.data || null; }
};

export const editarConceptoContabilidad = async (id_apartado, nombre) => {
    try {
        const response = await axios.put(baseUrl + 'conceptosContabilidad.php', { token: getCookie('PHPSESSID'), data: { id_apartado, nombre } });
        return response.data;
    } catch (error) { return error.response?.data || null; }
};

export const eliminarConceptoContabilidad = async (id_apartado) => {
    try {
        const response = await axios.delete(baseUrl + 'conceptosContabilidad.php', { data: { token: getCookie('PHPSESSID'), data: { id_apartado } } });
        return response.data;
    } catch (error) { return error.response?.data || null; }
};

export const crearConceptoPredefinidoContabilidad = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'conceptosPredefinidosContabilidad.php', { token: getCookie('PHPSESSID'), data });
        return response.data;
    } catch (error) { return error.response?.data || null; }
};

export const editarConceptoPredefinidoContabilidad = async (data) => {
    try {
        const response = await axios.put(baseUrl + 'conceptosPredefinidosContabilidad.php', { token: getCookie('PHPSESSID'), data });
        return response.data;
    } catch (error) { return error.response?.data || null; }
};

export const eliminarConceptoPredefinidoContabilidad = async (data) => {
    try {
        const response = await axios.delete(baseUrl + 'conceptosPredefinidosContabilidad.php', { data: { token: getCookie('PHPSESSID'), data } });
        return response.data;
    } catch (error) { return error.response?.data || null; }
};

export const getTicketsContabilidad = async (anyo) => {
    try {
        const response = await axios.get(baseUrl + 'ticketsContabilidad.php', { params: { token: getCookie('PHPSESSID'), anyo } });
        return response.data;
    } catch (error) { return error.response?.data || null; }
};

export const marcarTicketPagado = async (id_ticket_consumido, pagado = true, tipo_cobro = 'ticket', importe_pagado = null) => {
    try {
        const response = await axios.put(baseUrl + 'ticketsContabilidad.php', { token: getCookie('PHPSESSID'), data: { id_ticket_consumido, pagado: pagado ? 1 : 0, tipo_cobro, importe_pagado } });
        return response.data;
    } catch (error) { return error.response?.data || null; }
};

export const putIngreso = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'actualizarIngreso.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        console.log(response);

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postGasto = async (formData) => {
    try {
        const response = await axios.post(baseUrl + 'postGasto.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return null;
        }
    } catch (error) {
        console.error('Error al subir gasto:', error);
        return error.response?.data || null;
    }
};

export const putGasto = async (formData) => {
    try {
        const response = await axios.post(baseUrl + 'putGasto.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return response.data;
        }
    } catch (error) {
        console.error('Error al actualizar gasto:', error);
        return error.response?.data || null;
    }
};

export const deleteIngreso = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'deleteIngreso.php', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al eliminar ingreso:', error);
        return error.response?.data || null;
    }
};

export const deleteGasto = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'deleteGasto.php', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al eliminar gasto:', error);
        return error.response?.data || null;
    }
};

export const marcarGastoPagado = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'marcarGastoPagado.php', {
            token: getCookie('PHPSESSID'),
            data
        });

        return response.data;
    } catch (error) {
        console.error('Error al marcar gasto como pagado:', error);
        return error.response?.data || null;
    }
};

export const marcarIngresoPagado = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'marcarIngresoPagado.php', {
            token: getCookie('PHPSESSID'),
            data
        });
        return response.data;
    } catch (error) {
        console.error('Error al confirmar ingreso:', error);
        return error.response?.data || null;
    }
};

export const getImagenPrivada = async (path) => {
    try {
        const response = await axios.get(baseUrl + 'verImagenPrivada.php', {
            params: {
                token: getCookie('PHPSESSID'),
                path
            },
            responseType: 'blob'
        });

        return response.data;
    } catch (error) {
        console.error('Error al cargar imagen privada:', error);
        return null;
    }
};

export const getTiposEventos = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'tiposEventos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postEvento = async (formData) => {
    console.log(formData);

    try {
        const response = await axios.post(baseUrl + 'postEvento.php', {
            token: getCookie('PHPSESSID'),
            formData
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return response.data;
        }
    } catch (error) {
        console.error('Error al subir gasto:', error);
        return null;
    }
};

export const postAsistentes = async (formData) => {
    try {
        const response = await axios.post(baseUrl + 'postAsistentesEvento.php', {
            token: getCookie('PHPSESSID'),
            formData
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return response.data;
        }
    } catch (error) {
        console.error('Error al subir gasto:', error);
        return null;
    }
};

export const getComidas = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'todascomidas.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getEventos = async () => {
    try {
        const response = await axios.get(baseUrl + 'eventos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return response.data;
        }
    } catch (error) {
        console.error('Error al cargar eventos:', error);
        return null;
    }
};

export const postEventoUnificado = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'eventos.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return response.data;
        }
    } catch (error) {
        console.error('Error al crear evento:', error);
        return null;
    }
};

export const postComida = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'todascomidas.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return response.data;
        }
    } catch (error) {
        console.error('Error al crear comida:', error);
        return null;
    }
};

export const getActividades = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'todasactividades.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postActividad = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'todasactividades.php?', {
            token: getCookie('PHPSESSID'),
            data
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return response.data;
        }
    } catch (error) {
        console.error('Error al crear actividad:', error);
        return null;
    }
};

export const getRopa = async (mostrarEliminadas = false) => {
    try {
        const response = await axios.get(baseUrl + 'ropa.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                mostrar_eliminadas: mostrarEliminadas ? 1 : 0,
            },
        });

        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getMensajesTablon = async (year = new Date().getFullYear()) => {
    try {
        const response = await axios.get(baseUrl + 'mensajesTablon.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                year
            },
        });

        if (response) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response;
        } else {
            console.log('Error');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};
export const getTrabajadoresUsuario = async (tarea) => {
    try {
        const response = await axios.get(baseUrl + 'trabajadoresusuario.php?', {
            params: {
                token: getCookie('PHPSESSID'),
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getTicketsusuario = async (anyo = new Date().getFullYear()) => {
    try {
        const response = await axios.get(baseUrl + 'ticketsUsuarios.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                anyo,
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getResumenContabilidadUsuario = async (year = new Date().getFullYear()) => {
    try {
        const response = await axios.get(baseUrl + 'resumenContabilidadUsuario.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                year
            },
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.log('Error');
        }
    } catch (error) {
        console.error('Error al cargar resumen contable:', error);
        return null;
    }
};

export const postMensajeTablon = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'insertarMensajeTablon.php?', {
            token: getCookie('PHPSESSID'),
            data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


export const postRopa = async (data) => {
    try {
        const isFormData = data instanceof FormData;
        const payload = isFormData
            ? data
            : {
                token: getCookie('PHPSESSID'),
                data: data
            };

        if (isFormData && !payload.has('token')) {
            payload.append('token', getCookie('PHPSESSID'));
        }

        const response = await axios.post(baseUrl + 'ropa.php?', payload, isFormData ? {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        } : undefined);
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const deleteRopa = async (id, mostrarEliminadas = false) => {
    try {
        const response = await axios.delete(baseUrl + 'ropa.php?', {
            data: {
                token: getCookie('PHPSESSID'),
                mostrar_eliminadas: mostrarEliminadas ? 1 : 0,
                data: { id }
            }
        });

        return response.data;
    } catch (error) {
        console.error('Error en eliminar roba:', error);
        return error.response?.data || null;
    }
};

export const restaurarRopa = async (id, mostrarEliminadas = false) => {
    try {
        const response = await axios.put(baseUrl + 'ropa.php?', {
            token: getCookie('PHPSESSID'),
            mostrar_eliminadas: mostrarEliminadas ? 1 : 0,
            data: { id, eliminado: 0 }
        });

        return response.data;
    } catch (error) {
        console.error('Error en restaurar roba:', error);
        return error.response?.data || null;
    }
};

export const postBloquear = async (data) => {
    try {
        const response = await axios.post(baseUrl + 'bloquearcomida.php?', {
            token: getCookie('PHPSESSID'),
            data: data

        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario

            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getRegistrosEvento = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'registrosEvento.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getRegistrosContabilidad = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'registrosContabilidad.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const getAnuncios = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'anunciosActivos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};


export const getOpciones = async (id) => {
    try {
        const response = await axios.get(baseUrl + 'getOpciones.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                id: id
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('Error');
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const deleteFoto = async (id_foto) => {
    try {
        const response = await axios.post(baseUrl + 'deleteFoto.php',
            {
                id_foto: id_foto,
                token: getCookie('PHPSESSID'),
            }, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        if (response.data.success) {
            return response;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return null;
        }
    } catch (error) {
        console.error('Error al subir gasto:', error);
        return null;
    }
};

export const getFotos = async (fecha) => {
    try {
        const response = await axios.get(baseUrl + 'todasFotos.php?', {
            params: {
                token: getCookie('PHPSESSID'),
                data: fecha
            },
        });
        if (response.data.success) {
            // Procesar la respuesta y actualizar las opciones si es necesario
            return response.data;
        } else {
            console.log('No se pudo verificar el token');
            return null;
        }
    } catch (error) {
        console.error('Error al verificar el token:', error);
        return null;
    }
};

export const postComentarioFoto = async (formData) => {
    try {
        const response = await axios.post(baseUrl + 'postComentariosFoto.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return null;
        }
    } catch (error) {
        console.error('Error al subir gasto:', error);
        return null;
    }
};

export const toggleLikeFoto = async (formData) => {
    try {
        const response = await axios.post(baseUrl + 'likes.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            }
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return null;
        }
    } catch (error) {
        console.error('Error al subir gasto:', error);
        return null;
    }
};

export const postFoto = async (formData, onUploadProgress) => {
    try {
        const response = await axios.post(baseUrl + 'postFoto.php', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress
        });

        if (response.data.success) {
            return response.data;
        } else {
            console.error('Error en respuesta del servidor:', response.data);
            return null;
        }
    } catch (error) {
        console.error('Error al subir foto:', error);
        return null;
    }
};
